export default {
  nethrisEmployeurD: {
    TITLE: `Nethris/EmployeurD`,
    REGULAREARNINGCODE: {
      LABEL: `Code de gain temps régulier`,
      PLACEHOLDER: `Entrez un code commençant par la lettre G`,
      DESCRIPTION: ``
    },
    HOURLYRATE: {
      LABEL: `Taux horaire`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    DIVISION: {
      LABEL: `Division`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    SERVICE: {
      LABEL: `Service`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    DEPARTMENT: {
      LABEL: `Département`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    SUBDEPARTMENT: {
      LABEL: `Sous département`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    WORKS1: {
      LABEL: `Code de travail S1`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    WORKS2: {
      LABEL: `Code de travail S2`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    }
  },
  apogee: {
    TITLE: 'Apogée',
    FUNCCODE: {
      LABEL: `Func-Code`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    },
    FUNCTLEVEL: {
      LABEL: `Funct-Level`,
      PLACEHOLDER: `Entrez un code`,
      DESCRIPTION: ``
    }
  }
}
